import styled from 'styled-components';

import {ReactComponent as Svg} from '../../assets/shopping-bag.svg'

export const ShoppingIcon = styled(Svg)` 
width: 40px;
height: 40px;
`

export const CartIconContainer= styled.div`
    width: 45px;
    height: 45px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;`
  
  
export const ItemCount = styled.span` 
      position: absolute;
      font-size: 12px;
      font-weight: bold;
      bottom: 12px;
 `